import { useMemo } from "react";
import { useAppSelector as useSelector } from "../store/hooks";
import { normalizeInterfacePreferences } from "../utility/interfacePreferences";

export const useInterfacePreferences = () => {
  const storedPreferences = useSelector(
    (state) => state.settings?.interfacePreferences
  );

  return useMemo(
    () => normalizeInterfacePreferences(storedPreferences),
    [storedPreferences]
  );
};
